import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { VendorModule } from '../../../../../../modules/information/vendor';
import { DialogActionService } from 'src/app/Services/dialog-actions.service';
import { StorageService } from 'src/app/Services/storage.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/Services/shared.service';
import { Location } from '@angular/common';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

const urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.css']
})
export class AddVendorComponent implements OnInit {
  public vendorInfo = VendorModule;
  vendorDetails: any;
  userType: string;
  getUserData: any;
  userData: any;

  /* Vendor form variables */
  public addVendorForm:FormGroup;
  public formSubmitted:boolean = false;
  matFormSize = '13px';
  

  constructor(public api: ApiService,
              public dialogService: DialogActionService,
              public storage: StorageService,
              public router: Router,
              public location: Location,
              public swal: SweetAlert,
              public shared: SharedService) {
    this.userType = this.storage.get('userType');
    this.userData = this.storage.get('userInfo');
  }

  ngOnInit(): void {

    if (this.userType != 'transport_manager') {
      this.router.navigate(['/organization/transport-manager/login']);
    }
    console.log('getuser add vendor', this.getUserData);
    this.addFormLoad();
  }

  addFormLoad(){
    this.addVendorForm = new FormGroup({
      vendorName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      landline: new FormControl('', [Validators.required,Validators.pattern('[0-9]\\d{9}')]),
      zone: new FormControl('', [Validators.required,Validators.pattern('[a-z|A-Z_ ]*')]),
      address: new FormControl('', [Validators.required]),
      pincode: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{5}')]),
      domain: new FormControl('', [Validators.required,Validators.pattern(urlPattern)]),     
    });
  }
  /* Invidual form field check */
  public checkError = (controlName: string, errorName: string) => {
    return this.addVendorForm.controls[controlName].hasError(errorName);
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  submitted() {
    this.formSubmitted = true;
    if (!this.addVendorForm.valid) return;
    const obj = {
      orgID: this.userData.orgID,
      ...this.addVendorForm.value
    };
    obj.email = obj.email.toLowerCase();
    obj.domain = obj.domain.toLowerCase();
    this.api.transportManagerVendorCreate(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.swal.swalFunction('success', res.status, res.message, 2000);
        this.router.navigate(['/organization/transport-manager/information/vendor/view-vendor']);
      }
      if (res.status == 'failure') {
        if (res.message) {
          this.swal.swalFunction('error', res.status, res.message, 5000,'lowercase');
        }
      }
    }).catch((err) => {
      console.log(err);
    });

  }

}
